







































import { defineComponent, PropType, ref } from 'vue-demi';
import { downloadOfUrl } from '@zk/framework-vue';
import { useI18n } from 'common-module/src/util/useI18n';

export default defineComponent({
  name: 'RecordFailComponent',
  props: {
    recordUpload: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({})
    }
  },
  setup(props, { emit }) {

    const { t } = useI18n();

    const downloadLoading = ref(false);

    const handleDownload = () => {
      downloadLoading.value = true;
      try {
        const { mediaData, fileName } = props.recordUpload.recorderResult;
        const url = URL.createObjectURL(mediaData);
        downloadOfUrl(url, fileName);
      } finally {
        setTimeout(() => {
          downloadLoading.value = false;
        }, 1000);
      }
    };

    const handleRetry = () => {
      props.recordUpload?.retry?.();
      emit('retry');
    };

    return {
      t,
      handleDownload,
      handleRetry,
      downloadLoading
    };

  }
});
